'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');let

BaseDataService=function(_BaseService){_inherits(BaseDataService,_BaseService);
function BaseDataService($timeout){_classCallCheck(this,BaseDataService);var _this=_possibleConstructorReturn(this,
_BaseService.call(this));
_this._$timeout=$timeout;
_this._pendingUpdate=void 0;return _this;
}BaseDataService.prototype.

_update=function(){var ref=_asyncToGenerator(function*(){
throw new Error('abstract method not implemented');
});function _update(){return ref.apply(this,arguments)}return _update}();BaseDataService.prototype.

_clearCache=function _clearCache(){
throw new Error('abstract method not implemented');
};BaseDataService.prototype.

_clearPersistentData=function _clearPersistentData(){
throw new Error('abstract method not implemented');
};BaseDataService.prototype.





clearCache=function clearCache(){
if(_.exists(this._pendingUpdate)){
this._pendingUpdate.cancelled=!0;
this._pendingUpdate=void 0;
}
this._clearCache();
};BaseDataService.prototype.

clearAll=function clearAll(){
this.clearCache();
this._clearPersistentData();
};BaseDataService.prototype.

update=function(){var ref=_asyncToGenerator(function*(){var _this2=this;
let cancellationToken=this._startUpdate();
try{for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key]}
yield this._update.apply(this,[cancellationToken].concat(args));
}finally{
this._$timeout(function(){
_this2._completeUpdate(cancellationToken);
});
}
});function update(){for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2]}return ref.apply(this,arguments)}return update}();BaseDataService.prototype.

_startUpdate=function _startUpdate(){
if(_.exists(this._pendingUpdate)){
this._pendingUpdate.cancelled=!0;
}
this._pendingUpdate={cancelled:!1};
return this._pendingUpdate;
};BaseDataService.prototype.

_completeUpdate=function _completeUpdate(cancellationToken){
if(this._pendingUpdate===cancellationToken){
this._pendingUpdate=void 0;
}
};_createClass(BaseDataService,[{key:'isUpdating',get:function(){return _.exists(this._pendingUpdate)}}]);return BaseDataService}(BaseService);


module.exports=BaseDataService;
//# sourceMappingURL=baseDataService.js.map
